<template>
  <div class="trade">

    <div class="container-header">
      <div class="container-header__title">{{ i18n.lbl_trade() }}</div>
    </div>

    <div class="trade-block trade__container">
      <chart class="container container_40 trade__chart"
        :data="history"
        :volume="volume"
        :pairs="formattedPairs"
        :precision="common.precision"
        :assets="customAssetPair"
        v-on:assets-base-changed="handleAssetChange"
        v-on:assets-quote-changed="handleAssetChange"
      />
      <trade-history :assets="filters" class="container container_40 trade__history"/>
    </div>

    <div class="trade-block">
      <orders :assets="filters" class="md-layout-item md-size-100"/>
    </div>

    <div class="trade-block">
      <trade-orders :assets="filters" class="md-layout-item md-size-100"/>
    </div>

    <div class="trade-block">
      <manage-orders :assets="filters" :offers="userOffers" class="md-layout-item md-size-100"/>
    </div>

  </div>
</template>

<script>
  import config from '@conf'
  import Chart from './components/chart/Trade.ChartWidget'
  import TradeHistory from './components/tradeHistory/Trade.TradeHistory'
  import TradeOrders from './components/tradeOrders/Trade.TradeOrders'
  import Orders from './components/orders/Trade.Orders'
  import ManageOrders from './components/manageOrders/Trade.ManageOrders'
  import { chartsService } from '@api/charts.service'
  import { errors } from '@js/errors/factory'

  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { attachEventHandler } from '@js/events/helpers'
  import { commonEvents } from '@js/events/common_events'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { i18n } from '@js/i18n'

  export default {
    name: 'trade-index',
    components: {
      Chart,
      TradeHistory,
      TradeOrders,
      Orders,
      ManageOrders
    },
    data: _ => ({
      history: {},
      volume: {},
      tokenCode: '',
      filters: {
        base: '',
        quote: ''
      },
      i18n,
      customAssetPair: '',
      common: {
        precision: config.DECIMAL_POINTS
      }
    }),
    async created () {
      await this.loadPairs()
      await this.loadData(this.tradablePairs[0])
      attachEventHandler(commonEvents.changePairsAsset, this.handleAssetChange)
      attachEventHandler(commonEvents.cancelOrder, this.handleCancelOrder)
      attachEventHandler(commonEvents.createdOrder, this.handleCreatedOffer)
      this.filters.base = this.formattedPairs[0].split('/')[0]
      this.filters.quote = this.formattedPairs[0].split('/')[1]
      this.customAssetPair = this.formattedPairs[0]
    },
    computed: {
      ...mapGetters([
        vuexTypes.tradablePairs,
        vuexTypes.userOffers
      ]),
      formattedPairs () {
        return this.tradablePairs.map((el) => {
          return `${el.base}/${el.quote}`
        })
      }
    },
    methods: {
      ...mapActions({
        loadPairs: vuexTypes.GET_ASSET_PAIRS,
        loadOrders: vuexTypes.GET_SM_OFFERS,
        loadTrades: vuexTypes.GET_TRADES,
        loadUserOffers: vuexTypes.GET_USER_OFFERS
      }),
      async loadData (pair) {
        if (!pair) return
        await Promise.all([
          this.loadOrders(pair),
          this.loadPrices(pair),
          this.loadTrades(pair),
          this.loadUserOffers(pair)
        ])
        // this.updateTradesByInterval()
      },
      // updateTradesByInterval () {
      //   clearInterval(this.tradesUpdateInterval)
      //   this.tradesUpdateInterval = setInterval(async () => {
      //     await this.loadPrices(this.filters)
      //   }, this.tradesUpdateIntervalValue)
      // },
      async loadPrices ({base, quote}) {
        try {
          const [ history, volume ] = await Promise.all([
            chartsService.loadChartsForTokenPair(base, quote),
            chartsService.loadVolumeChartsForTokenPair(base, quote)
          ])
          this.history = history.data()
          this.volume = volume.data()
        } catch (error) {
          if (error instanceof errors.NotFoundError) {
            console.log('error')
            ErrorHandler.processUnexpected(error)
          }
        }
      },
      handleAssetChange (payload) {
        this.filters.base = payload.split('/')[0]
        this.filters.quote = payload.split('/')[1]
        this.customAssetPair = payload
        this.loadData(this.filters)
      },
      handleCancelOrder () {
        this.loadData(this.filters)
      },
      handleCreatedOffer () {
        this.loadData(this.filters)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .trade {
    max-width: 1200px;

    &__container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      & .trade__history {
        margin-top: 16px;
      }

      .trade__history,
      .trade__chart {
        flex: 1 1 100%;
        width: 100%;
      }
    }
  }

  .trade-block {
    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/Trade.Index.vue